import BankIdApp from '@features/BankIdApp/Scripts/BankIdApp.vue';
import { createApp } from 'vue';

const el = document.getElementById('bank-id-app');

if (el) {
    createApp(BankIdApp).mount(el);
}